import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "ori-label" }
const _hoisted_3 = { class: "w-100 text-center" }
const _hoisted_4 = { class: "w-100 text-center" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = ["onClick"]

import {computed, ref, onMounted, watch} from "vue";
import BGrid from "../BGrid/BGrid.vue";
import {useNoticeStore} from "@/stores/noticeStore";
import {NoticeItem} from "./types";
import NoticeDetails from "./NoticeDetails.vue";
import InformationModal from "../Misc/InformationModal.vue";
import {BFilter} from "../BFilterEditor/BFilterEditor.types";
import hasPermission from "@/composable/permissionHelper";
import {useOriStore} from "@/stores/oriStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AllNotices',
  setup(__props) {

const noticeStore = useNoticeStore();

var selectedRow = ref({} as NoticeItem);
var noticeDetailsModal = ref(false);

var oriStore = useOriStore();
oriStore.dataset = undefined;

function handleDescriptionClick(item: NoticeItem) {
    selectedRow.value = item;
    noticeDetailsModal.value = true;
}

async function handleNoticeDetailsModalDismiss(isSubmit: boolean) {
    selectedRow.value = {} as NoticeItem;
    noticeDetailsModal.value = false;

    if (isSubmit) {
        await noticeStore.allNotices();
    }
}

onMounted(async () => {
    noticeStore.noticeFilterOptions.filters.push({property: "dismissed", operation: "eq", value: false} as BFilter);
    await noticeStore.allNotices();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NoticeDetails, {
      item: _unref(selectedRow),
      "show-notice-details-modal": _unref(noticeDetailsModal),
      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (handleNoticeDetailsModalDismiss(true))),
      onDismiss: _cache[1] || (_cache[1] = ($event: any) => (handleNoticeDetailsModalDismiss(false)))
    }, null, 8, ["item", "show-notice-details-modal"]),
    _createVNode(BGrid, {
      caption: "All Notices",
      filterableFields: _unref(noticeStore).filterableNoticeFields,
      filterOptions: _unref(noticeStore).noticeFilterOptions,
      tableOptions: _unref(noticeStore).allNoticesTableOptions,
      items: _unref(noticeStore).noticeItems,
      columns: _unref(noticeStore).columns,
      "show-filter": true,
      "show-paging": true,
      onOptionChange: _unref(noticeStore).allNotices
    }, {
      "cell.agencyList": _withCtx(({item, column}) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.ori), 1)
      ]),
      "header.dismissed": _withCtx(({column}) => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(column.text), 1)
      ]),
      "cell.dismissed": _withCtx(({item, column}) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            class: "",
            disabled: "true",
            readonly: "",
            type: "checkbox",
            checked: item.is_dismissed
          }, null, 8, _hoisted_5)
        ])
      ]),
      "cell.description": _withCtx(({item, column}) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link ps-0",
          onClick: _withModifiers(($event: any) => (handleDescriptionClick(item)), ["prevent"])
        }, _toDisplayString(item.description), 9, _hoisted_6)
      ]),
      _: 1
    }, 8, ["filterableFields", "filterOptions", "tableOptions", "items", "columns", "onOptionChange"])
  ]))
}
}

})